/** Same wording as the one-off toast in material-planning/generate-new-link. */
export const DESIGN_SCOPE_ACTION_ERROR = "An error occurred";

export function designScopeActionErrorMessage(
  errorMsg?: string | null
): string {
  const text = errorMsg?.trim();
  return text || DESIGN_SCOPE_ACTION_ERROR;
}

export const DESIGN_SCOPE_CSV_FILE_ERROR = "Select a CSV file.";

export const DESIGN_SCOPE_LIST_IMPORTED = "Design scope list imported.";

export const DESIGN_SCOPE_ITEMS_IMPORTED = "Design scope items imported.";

export const DESIGN_SCOPE_LIST_DELETED = "Design scope list deleted.";

export const DESIGN_SCOPE_LIST_TITLE_UPDATED = "List title updated.";

export const DESIGN_SCOPE_LIST_DESCRIPTION_UPDATED =
  "List description updated.";

export const DESIGN_SCOPE_ITEM_ADDED = "Scope item added.";

export const DESIGN_SCOPE_ITEM_DELETED = "Scope item deleted.";

export function scopeItemUpdatedMessage(colId: string): string {
  switch (colId) {
    case "title":
      return "Scope item title updated.";
    case "description":
      return "Scope item description updated.";
    case "uniformat":
      return "UniFormat updated.";
    case "masterformat":
      return "MasterFormat updated.";
    default:
      return "Scope item updated.";
  }
}
